var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (allShows, artist, displayContextualLabel, displayLocation, featuredShows, fromShowGuide, shows, undefined) {
if ( featuredShows.length)
{
buf.push("<div id=\"home-featured-shows-section\" data-context=\"featured shows\" class=\"js-homepage-featured-links\"><h2 class=\"home-featured-header\"><span class=\"home-featured-header__title\">Featured Shows</span><div class=\"home-browse-all-right\"><a href=\"/shows\">Explore all shows</a></div></h2><ul id=\"home-featured-shows\" class=\"home-featured-list\">");
allShows = featuredShows.take(8)
displayLocation = true
shows = allShows.slice(0, 2)
var width = 660
var height = 440
buf.push("<ul class=\"grid-2-up\">");
// iterate shows
;(function(){
  var $$obj = shows;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var show = $$obj[$index];

displayLocation = displayLocation || false
displayContextualLabel = displayContextualLabel || false
if ( show.has('image_versions') && show.get('image_versions').length)
{
buf.push("<li class=\"featured-shows-featured-show grid-item\"><a" + (jade.attr("href", show.href() + (fromShowGuide ? '?from-show-guide=true' : ''), true, true)) + " class=\"hoverable-image-link\"><img" + (jade.attr("src", show.cropUrlFor({ width: width, height: height }), true, true)) + (jade.attr("alt", show.get('name'), true, true)) + " onerror=\"this.style.display=&quot;none&quot;;\" class=\"fsfs-cover-image\"></a><a" + (jade.attr("href", show.href() + (fromShowGuide ? '?from-show-guide=true' : ''), true, true)) + " class=\"fsfs-metadata\">");
if ( displayContextualLabel)
{
buf.push("<h5 class=\"fsfs-contextual-label\">" + (jade.escape(null == (jade_interp = show.contextualLabel(artist && artist.get('name'))) ? "" : jade_interp)) + "</h5>");
}
buf.push("<h4 class=\"fsfs-partner-name\">" + (jade.escape(null == (jade_interp = show.partnerName()) ? "" : jade_interp)) + "</h4><h5 class=\"fsfs-show-name\">" + (jade.escape(null == (jade_interp = show.get('name')) ? "" : jade_interp)) + "</h5>");
if ( displayLocation)
{
buf.push("<div class=\"fsfs-running-dates\">");
if ( show.formatCity())
{
buf.push(jade.escape(null == (jade_interp = show.formatCity() + ", ") ? "" : jade_interp));
}
else if ( show.isOnlineExclusive())
{
buf.push(jade.escape(null == (jade_interp = "Online Exclusive, ") ? "" : jade_interp));
}
if ( show.upcoming())
{
buf.push("Opening " + (jade.escape((jade_interp = show.dateFormatted('start_at')) == null ? '' : jade_interp)) + "");
}
else if ( show.isEndingSoon())
{
buf.push("<span class=\"fsfs-warning\">Closing " + (jade.escape((jade_interp = show.endingIn()) == null ? '' : jade_interp)) + "</span>");
}
else
{
buf.push("" + (jade.escape((jade_interp = show.date('start_at').format('MMM DD')) == null ? '' : jade_interp)) + " – " + (jade.escape((jade_interp = show.dateFormatted('end_at')) == null ? '' : jade_interp)) + "");
}
buf.push("</div>");
}
else
{
if ( show.formatStreetAddress())
{
buf.push("<div class=\"fsfs-street-address\">" + (jade.escape(null == (jade_interp = show.formatStreetAddress()) ? "" : jade_interp)) + "</div>");
}
if ( show.get('status') === 'upcoming')
{
buf.push("<div class=\"fsfs-running-dates\">");
if ( show.isOpeningToday())
{
buf.push("Opening today");
}
else
{
buf.push("Opening " + (jade.escape((jade_interp = show.dateFormatted('start_at')) == null ? '' : jade_interp)) + "");
}
buf.push("</div>");
}
if ( show.get('status') === 'closed')
{
buf.push("<div class=\"fsfs-running-dates\">" + (jade.escape((jade_interp = show.date('start_at').format('MMM DD')) == null ? '' : jade_interp)) + " – " + (jade.escape((jade_interp = show.dateFormatted('end_at')) == null ? '' : jade_interp)) + "</div>");
}
if ( show.isEndingSoon())
{
buf.push("<div class=\"fsfs-warning\">Closing " + (jade.escape((jade_interp = show.endingIn()) == null ? '' : jade_interp)) + "</div>");
}
else if ( show.get('status') === 'running')
{
buf.push("<div class=\"fsfs-closing-date\">");
if ( show.date('end_at').isBefore())
{
buf.push("Closed");
}
else
{
buf.push("Closes");
}
buf.push((jade.escape(null == (jade_interp = ' ') ? "" : jade_interp)) + (jade.escape(null == (jade_interp = show.dateFormatted('end_at')) ? "" : jade_interp)) + "</div>");
}
}
buf.push("</a></li>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var show = $$obj[$index];

displayLocation = displayLocation || false
displayContextualLabel = displayContextualLabel || false
if ( show.has('image_versions') && show.get('image_versions').length)
{
buf.push("<li class=\"featured-shows-featured-show grid-item\"><a" + (jade.attr("href", show.href() + (fromShowGuide ? '?from-show-guide=true' : ''), true, true)) + " class=\"hoverable-image-link\"><img" + (jade.attr("src", show.cropUrlFor({ width: width, height: height }), true, true)) + (jade.attr("alt", show.get('name'), true, true)) + " onerror=\"this.style.display=&quot;none&quot;;\" class=\"fsfs-cover-image\"></a><a" + (jade.attr("href", show.href() + (fromShowGuide ? '?from-show-guide=true' : ''), true, true)) + " class=\"fsfs-metadata\">");
if ( displayContextualLabel)
{
buf.push("<h5 class=\"fsfs-contextual-label\">" + (jade.escape(null == (jade_interp = show.contextualLabel(artist && artist.get('name'))) ? "" : jade_interp)) + "</h5>");
}
buf.push("<h4 class=\"fsfs-partner-name\">" + (jade.escape(null == (jade_interp = show.partnerName()) ? "" : jade_interp)) + "</h4><h5 class=\"fsfs-show-name\">" + (jade.escape(null == (jade_interp = show.get('name')) ? "" : jade_interp)) + "</h5>");
if ( displayLocation)
{
buf.push("<div class=\"fsfs-running-dates\">");
if ( show.formatCity())
{
buf.push(jade.escape(null == (jade_interp = show.formatCity() + ", ") ? "" : jade_interp));
}
else if ( show.isOnlineExclusive())
{
buf.push(jade.escape(null == (jade_interp = "Online Exclusive, ") ? "" : jade_interp));
}
if ( show.upcoming())
{
buf.push("Opening " + (jade.escape((jade_interp = show.dateFormatted('start_at')) == null ? '' : jade_interp)) + "");
}
else if ( show.isEndingSoon())
{
buf.push("<span class=\"fsfs-warning\">Closing " + (jade.escape((jade_interp = show.endingIn()) == null ? '' : jade_interp)) + "</span>");
}
else
{
buf.push("" + (jade.escape((jade_interp = show.date('start_at').format('MMM DD')) == null ? '' : jade_interp)) + " – " + (jade.escape((jade_interp = show.dateFormatted('end_at')) == null ? '' : jade_interp)) + "");
}
buf.push("</div>");
}
else
{
if ( show.formatStreetAddress())
{
buf.push("<div class=\"fsfs-street-address\">" + (jade.escape(null == (jade_interp = show.formatStreetAddress()) ? "" : jade_interp)) + "</div>");
}
if ( show.get('status') === 'upcoming')
{
buf.push("<div class=\"fsfs-running-dates\">");
if ( show.isOpeningToday())
{
buf.push("Opening today");
}
else
{
buf.push("Opening " + (jade.escape((jade_interp = show.dateFormatted('start_at')) == null ? '' : jade_interp)) + "");
}
buf.push("</div>");
}
if ( show.get('status') === 'closed')
{
buf.push("<div class=\"fsfs-running-dates\">" + (jade.escape((jade_interp = show.date('start_at').format('MMM DD')) == null ? '' : jade_interp)) + " – " + (jade.escape((jade_interp = show.dateFormatted('end_at')) == null ? '' : jade_interp)) + "</div>");
}
if ( show.isEndingSoon())
{
buf.push("<div class=\"fsfs-warning\">Closing " + (jade.escape((jade_interp = show.endingIn()) == null ? '' : jade_interp)) + "</div>");
}
else if ( show.get('status') === 'running')
{
buf.push("<div class=\"fsfs-closing-date\">");
if ( show.date('end_at').isBefore())
{
buf.push("Closed");
}
else
{
buf.push("Closes");
}
buf.push((jade.escape(null == (jade_interp = ' ') ? "" : jade_interp)) + (jade.escape(null == (jade_interp = show.dateFormatted('end_at')) ? "" : jade_interp)) + "</div>");
}
}
buf.push("</a></li>");
}
    }

  }
}).call(this);

buf.push("</ul>");
shows = allShows.slice(2)
var width = 420
var height = 280
buf.push("<ul class=\"grid-3-up\">");
// iterate shows
;(function(){
  var $$obj = shows;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var show = $$obj[$index];

displayLocation = displayLocation || false
displayContextualLabel = displayContextualLabel || false
if ( show.has('image_versions') && show.get('image_versions').length)
{
buf.push("<li class=\"featured-shows-featured-show grid-item\"><a" + (jade.attr("href", show.href() + (fromShowGuide ? '?from-show-guide=true' : ''), true, true)) + " class=\"hoverable-image-link\"><img" + (jade.attr("src", show.cropUrlFor({ width: width, height: height }), true, true)) + (jade.attr("alt", show.get('name'), true, true)) + " onerror=\"this.style.display=&quot;none&quot;;\" class=\"fsfs-cover-image\"></a><a" + (jade.attr("href", show.href() + (fromShowGuide ? '?from-show-guide=true' : ''), true, true)) + " class=\"fsfs-metadata\">");
if ( displayContextualLabel)
{
buf.push("<h5 class=\"fsfs-contextual-label\">" + (jade.escape(null == (jade_interp = show.contextualLabel(artist && artist.get('name'))) ? "" : jade_interp)) + "</h5>");
}
buf.push("<h4 class=\"fsfs-partner-name\">" + (jade.escape(null == (jade_interp = show.partnerName()) ? "" : jade_interp)) + "</h4><h5 class=\"fsfs-show-name\">" + (jade.escape(null == (jade_interp = show.get('name')) ? "" : jade_interp)) + "</h5>");
if ( displayLocation)
{
buf.push("<div class=\"fsfs-running-dates\">");
if ( show.formatCity())
{
buf.push(jade.escape(null == (jade_interp = show.formatCity() + ", ") ? "" : jade_interp));
}
else if ( show.isOnlineExclusive())
{
buf.push(jade.escape(null == (jade_interp = "Online Exclusive, ") ? "" : jade_interp));
}
if ( show.upcoming())
{
buf.push("Opening " + (jade.escape((jade_interp = show.dateFormatted('start_at')) == null ? '' : jade_interp)) + "");
}
else if ( show.isEndingSoon())
{
buf.push("<span class=\"fsfs-warning\">Closing " + (jade.escape((jade_interp = show.endingIn()) == null ? '' : jade_interp)) + "</span>");
}
else
{
buf.push("" + (jade.escape((jade_interp = show.date('start_at').format('MMM DD')) == null ? '' : jade_interp)) + " – " + (jade.escape((jade_interp = show.dateFormatted('end_at')) == null ? '' : jade_interp)) + "");
}
buf.push("</div>");
}
else
{
if ( show.formatStreetAddress())
{
buf.push("<div class=\"fsfs-street-address\">" + (jade.escape(null == (jade_interp = show.formatStreetAddress()) ? "" : jade_interp)) + "</div>");
}
if ( show.get('status') === 'upcoming')
{
buf.push("<div class=\"fsfs-running-dates\">");
if ( show.isOpeningToday())
{
buf.push("Opening today");
}
else
{
buf.push("Opening " + (jade.escape((jade_interp = show.dateFormatted('start_at')) == null ? '' : jade_interp)) + "");
}
buf.push("</div>");
}
if ( show.get('status') === 'closed')
{
buf.push("<div class=\"fsfs-running-dates\">" + (jade.escape((jade_interp = show.date('start_at').format('MMM DD')) == null ? '' : jade_interp)) + " – " + (jade.escape((jade_interp = show.dateFormatted('end_at')) == null ? '' : jade_interp)) + "</div>");
}
if ( show.isEndingSoon())
{
buf.push("<div class=\"fsfs-warning\">Closing " + (jade.escape((jade_interp = show.endingIn()) == null ? '' : jade_interp)) + "</div>");
}
else if ( show.get('status') === 'running')
{
buf.push("<div class=\"fsfs-closing-date\">");
if ( show.date('end_at').isBefore())
{
buf.push("Closed");
}
else
{
buf.push("Closes");
}
buf.push((jade.escape(null == (jade_interp = ' ') ? "" : jade_interp)) + (jade.escape(null == (jade_interp = show.dateFormatted('end_at')) ? "" : jade_interp)) + "</div>");
}
}
buf.push("</a></li>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var show = $$obj[$index];

displayLocation = displayLocation || false
displayContextualLabel = displayContextualLabel || false
if ( show.has('image_versions') && show.get('image_versions').length)
{
buf.push("<li class=\"featured-shows-featured-show grid-item\"><a" + (jade.attr("href", show.href() + (fromShowGuide ? '?from-show-guide=true' : ''), true, true)) + " class=\"hoverable-image-link\"><img" + (jade.attr("src", show.cropUrlFor({ width: width, height: height }), true, true)) + (jade.attr("alt", show.get('name'), true, true)) + " onerror=\"this.style.display=&quot;none&quot;;\" class=\"fsfs-cover-image\"></a><a" + (jade.attr("href", show.href() + (fromShowGuide ? '?from-show-guide=true' : ''), true, true)) + " class=\"fsfs-metadata\">");
if ( displayContextualLabel)
{
buf.push("<h5 class=\"fsfs-contextual-label\">" + (jade.escape(null == (jade_interp = show.contextualLabel(artist && artist.get('name'))) ? "" : jade_interp)) + "</h5>");
}
buf.push("<h4 class=\"fsfs-partner-name\">" + (jade.escape(null == (jade_interp = show.partnerName()) ? "" : jade_interp)) + "</h4><h5 class=\"fsfs-show-name\">" + (jade.escape(null == (jade_interp = show.get('name')) ? "" : jade_interp)) + "</h5>");
if ( displayLocation)
{
buf.push("<div class=\"fsfs-running-dates\">");
if ( show.formatCity())
{
buf.push(jade.escape(null == (jade_interp = show.formatCity() + ", ") ? "" : jade_interp));
}
else if ( show.isOnlineExclusive())
{
buf.push(jade.escape(null == (jade_interp = "Online Exclusive, ") ? "" : jade_interp));
}
if ( show.upcoming())
{
buf.push("Opening " + (jade.escape((jade_interp = show.dateFormatted('start_at')) == null ? '' : jade_interp)) + "");
}
else if ( show.isEndingSoon())
{
buf.push("<span class=\"fsfs-warning\">Closing " + (jade.escape((jade_interp = show.endingIn()) == null ? '' : jade_interp)) + "</span>");
}
else
{
buf.push("" + (jade.escape((jade_interp = show.date('start_at').format('MMM DD')) == null ? '' : jade_interp)) + " – " + (jade.escape((jade_interp = show.dateFormatted('end_at')) == null ? '' : jade_interp)) + "");
}
buf.push("</div>");
}
else
{
if ( show.formatStreetAddress())
{
buf.push("<div class=\"fsfs-street-address\">" + (jade.escape(null == (jade_interp = show.formatStreetAddress()) ? "" : jade_interp)) + "</div>");
}
if ( show.get('status') === 'upcoming')
{
buf.push("<div class=\"fsfs-running-dates\">");
if ( show.isOpeningToday())
{
buf.push("Opening today");
}
else
{
buf.push("Opening " + (jade.escape((jade_interp = show.dateFormatted('start_at')) == null ? '' : jade_interp)) + "");
}
buf.push("</div>");
}
if ( show.get('status') === 'closed')
{
buf.push("<div class=\"fsfs-running-dates\">" + (jade.escape((jade_interp = show.date('start_at').format('MMM DD')) == null ? '' : jade_interp)) + " – " + (jade.escape((jade_interp = show.dateFormatted('end_at')) == null ? '' : jade_interp)) + "</div>");
}
if ( show.isEndingSoon())
{
buf.push("<div class=\"fsfs-warning\">Closing " + (jade.escape((jade_interp = show.endingIn()) == null ? '' : jade_interp)) + "</div>");
}
else if ( show.get('status') === 'running')
{
buf.push("<div class=\"fsfs-closing-date\">");
if ( show.date('end_at').isBefore())
{
buf.push("Closed");
}
else
{
buf.push("Closes");
}
buf.push((jade.escape(null == (jade_interp = ' ') ? "" : jade_interp)) + (jade.escape(null == (jade_interp = show.dateFormatted('end_at')) ? "" : jade_interp)) + "</div>");
}
}
buf.push("</a></li>");
}
    }

  }
}).call(this);

buf.push("</ul></ul></div>");
}}.call(this,"allShows" in locals_for_with?locals_for_with.allShows:typeof allShows!=="undefined"?allShows:undefined,"artist" in locals_for_with?locals_for_with.artist:typeof artist!=="undefined"?artist:undefined,"displayContextualLabel" in locals_for_with?locals_for_with.displayContextualLabel:typeof displayContextualLabel!=="undefined"?displayContextualLabel:undefined,"displayLocation" in locals_for_with?locals_for_with.displayLocation:typeof displayLocation!=="undefined"?displayLocation:undefined,"featuredShows" in locals_for_with?locals_for_with.featuredShows:typeof featuredShows!=="undefined"?featuredShows:undefined,"fromShowGuide" in locals_for_with?locals_for_with.fromShowGuide:typeof fromShowGuide!=="undefined"?fromShowGuide:undefined,"shows" in locals_for_with?locals_for_with.shows:typeof shows!=="undefined"?shows:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;